import { useState, useCallback } from 'react'

function usePagination(initialPagination, onPageChange, onPerPageChange) {
  const initial = initialPagination || {}

  const [pagination, setPagination] = useState({
    currentPage: initial.currentPage || 1,
    perPage: initial.perPage || 40,
    totalPages: initial.totalPages || 1,
    totalCount: initial.totalCount || 0,
  })

  const handlePageChange = useCallback((page) => {
    setPagination((prev) => ({ ...prev, currentPage: page }))
    if (onPageChange) onPageChange(page, pagination.perPage)
  }, [onPageChange, pagination.perPage])

  const handlePerPageChange = useCallback((newPerPage) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
      perPage: newPerPage,
      totalPages: Math.ceil(prev.totalCount / newPerPage),
    }))
    if (onPerPageChange) onPerPageChange(1, newPerPage)
  }, [onPerPageChange])

  return {
    currentPage: pagination.currentPage,
    perPage: pagination.perPage,
    totalPages: pagination.totalPages,
    totalCount: pagination.totalCount,
    handlePageChange,
    handlePerPageChange,
    setPagination,
  }
}

export default usePagination
